import { render, staticRenderFns } from "./AiRequestsOverview.vue?vue&type=template&id=6445e0d5"
import script from "./AiRequestsOverview.vue?vue&type=script&lang=js"
export * from "./AiRequestsOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports